import axios from 'axios'

const state = () => ({
  all: [],
})

const getters = {
  all (state) {
    return state.all
  },
}

const mutations = {
  SET_DEPARTMENTS (state, departments) {
    state.all = departments
  },
}

const actions = {
  async index ({ commit }, params) {
    const response = await axios.get('/departments', { params })
    commit('SET_DEPARTMENTS', response.data.data)
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}